import { render, staticRenderFns } from "./setMealAllocation.vue?vue&type=template&id=2f47b6a1&scoped=true&"
import script from "./setMealAllocation.vue?vue&type=script&lang=js&"
export * from "./setMealAllocation.vue?vue&type=script&lang=js&"
import style0 from "./setMealAllocation.vue?vue&type=style&index=0&id=2f47b6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47b6a1",
  null
  
)

export default component.exports